import { Box } from '@mui/material';
import axios from 'axios';
import { useEffect, useState } from 'react';
import IResponse from '../../../interfaces/response';
import InformationCard from '../../common/InformationCard';
import { useTranslation } from 'react-i18next';

const MarketersState = () => {
	const [data, setData] = useState([]);
	const { t } = useTranslation();
	useEffect(() => {
		axios<IResponse<any>>({
			url: `/admin/admins/marketer/stats`,
		}).then(res => {
			if (res.data.success) {
				setData(res.data.data);
			}
		});
	}, []);
	return (
		<Box className="flex flex-wrap justify-center gap-7">
			{Object.entries(data).map(([key, value]) => (
				<div className="w-1/5">
					<InformationCard title={`${t('campaign_marketer')} ${t(`${key}`)}`} color="primary" description={value} />
				</div>
			))}
		</Box>
	);
};

export default MarketersState;
